
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import CustomUploadApi from "~/api/custom-upload";
import UploadApi from "~/api/upload-api"
import OCROrderApi from "~/api/ocr-order-api"
import OCRApi from "@/api/ocr-api";
import { ImagePreview, Toast } from "vant";
import { imageFileToWebp } from "~/utils/image";
import eventBus from "@/utils/event-bus";
import ItemEditorPhoto from './item-editor-photo.vue'
import ItemEditorQty from "./item-editor-qty.vue"
import Config from "./config"
//import { PartNoRemark } from "./config"
// import Keyboard from "~/components/common/keyboard.vue";

const C_UPLOAD_FILE_TYPE = "hk_receipt_info"
type QTYCheckResult = { qty: number, pcs: number, qtyWaring: boolean, pcsWaring: boolean }
type ImageInfo = { id: NString, url: string, isFile?: boolean, scanning?: boolean, ocr?: OCRApi.IOCRResult }
type PickFields = "Package" | keyof OCRApi.IOCRResult
@Component({ name: "item-editor-custom", components: { ItemEditorPhoto, ItemEditorQty } })
export default class ItemEditorCustom extends Vue {
    showPicker = false
    loading = 0
    pnField: PickFields = "All"
    partNo: OCROrderApi.IOcrOrderReceiptItem & IAnitReplayModel = { CheckStatus: 0, CaseNo: undefined, PackagingInfos: [], _noise: Math.random() } as any

    ocrResult: OCRApi.IOCRResult & Record<keyof OCRApi.IOCRResult, OCRApi.IOCRResultItem[]> = {} as any;

    ocrScan: boolean = false
    //imgs: string[] = ['902c73d5-1509-47d5-ab1e-8288a5a4f02e']
    imgs: ImageInfo[] = []
    randKey = ""
    detailInfo = { orderId: 0, partNoId: 0, orderNo: '' }
    // webp = ""
    sessionId = ""

    get checkStatus() { return !!this.partNo.CheckStatus; }
    set checkStatus(v: boolean) { this.$set(this.partNo, "CheckStatus", v ? 1 : 0); }


    get pickerData(): Array<OCRApi.IOCRResultItem> {
        const f = this.pnField
        if (f == "Package") return this.packages;
        if (f) {
            var rlt = this.ocrResult;
            var n = rlt[f]
            if (!Array.isNullOrEmpty(n)) return n
        }
        const all = this.ocrResult.All || [];
        return all.map(e => ({ Recommendder: 0, Text: e }))
    }

    get imgUrls() {
        return this.imgs.map(e => e.url);
    }

    get packages() {
        const pn = this.partNo.PartNo?.toUpperCase();
        if (!pn) return [];
        if (!this.ocrResult || !this.ocrResult.PartNo) return []
        var p = this.ocrResult.PartNo.find(e => e.Text == pn)?.Package.map(e => ({ Text: e, Recommendder: 0 } as OCRApi.IOCRResultItem));
        return p || []
    }

    /** 是否有无效的 数量分组 */
    get hasInvalidQtyGroup() {
        const pis = this.partNo.PackagingInfos;
        if (Array.isNullOrEmpty(pis)) return false;
        return pis.some(e => !Number(e.Qty) || 0)
    }

    created() {
        const { orderId, caseNo, id } = this.$route.query
        this.partNo.CaseNo = caseNo as string
        this.detailInfo.orderId = orderId as any
        this.detailInfo.partNoId = id as any
        if (id) this.loadPartNo();
        else this.loadCaseinfo();
    }
    mounted() { }
    loadPartNo() {
        eventBus.emit("set-nav-right", { title: '删除', onClick: this.del, class: "red" })
        OCROrderApi.getLineDetail(this.detailInfo.orderId, this.detailInfo.partNoId)
            .then(e => {
                const detail = e.Detail[0]
                let pk = detail.PackagingInfos;
                if (!pk || pk.length == 0) {
                    pk = [
                        {
                            PCS: 1,
                            AsKilo: false,
                            Qty: 0,
                            AgentOrderDetailReceiptInfoId: detail.Id,
                            Type: Config.DefaultMpqUnitType
                        },
                        {
                            PCS: 1,
                            AsKilo: false,
                            Qty: detail.Qty,
                            AgentOrderDetailReceiptInfoId: detail.Id,
                            Type: OCROrderApi.PackagingUnit.None
                        }]
                    e.Detail[0].PackagingInfos = pk;
                }
                this.detailInfo.orderNo = e.OrderNo!;
                var p = Array.firstOrDefault(e.Detail)!;
                if (!p) {
                    this.$toast("未找到收货信息")
                    this.goBack();
                    return;
                }
                this.partNo = p;
                if (Array.isNullOrEmpty(p.PackagingInfos)) this.addPcs();
                const ptr: UploadApi.IFileListParam = {} as any;
                ptr.RelationType = C_UPLOAD_FILE_TYPE;
                ptr.RelationId = p.Id;
                UploadApi.getFiles(ptr).then(e => this.imgs = e.map(e => ({ id: e.Id!, url: this.fileIdToUrl(e.Id) })))
            }).catch(this.goBack)
    }

    fileIdToUrl(id: NString) {
        return `/api/Download/GetFile?id=${id}`
    }

    async loadCaseinfo() {
        eventBus.emit("set-nav-right", { title: '清空', onClick: this.del, class: 'red' })
        OCROrderApi.getLineDetail(this.detailInfo.orderId, 0, this)
            .then(e => {
                //var item = Array.firstOrDefault(e)!;
                this.detailInfo.orderNo = e.OrderNo!;
                var { scan } = this.$route.query
                if (scan) this.takePhoto(true)
                this.addPcs();
            })
            .catch(this.goBack)
    }

    async onSubmit() {
        const msg = this.fromCheck();
        if (msg) {
            this.$toast({ message: msg })
            return;
        }

        this.partNo.OrderId = this.detailInfo.orderId;
        this.partNo.FileSession = this.sessionId;
        OCROrderApi.edit(this.partNo, this).then(e => {
            this.$toast("保存成功")
            if (this.partNo.Id) this.goBack(); //edit to back
            else this.newPartNo(); // new item , renew 
        })
    }

    goBack() {
        this.$router.back();
        //this.$router.push({ name: "ocr-order-detail", query: { id: this.detailInfo.orderId } as any })
    }
    /** 清空数据，重新录入 */
    newPartNo() {
        var cn = this.partNo.CaseNo;
        var pn: OCROrderApi.IOcrOrderReceiptItem = {} as any
        pn.CaseNo = this.partNo.CaseNo;
        pn.PalletNo = this.partNo.PalletNo;
        this.partNo = pn;
        this.sessionId = undefined as any;
        this.imgs = []

        this.addPcs();
        this.partNo._noise = Math.random();
    }


    getQty(p: OCROrderApi.IReceiptPackagingInfo) {
        return (p.Qty * (p.AsKilo ? 1000 : 1)) || 0;
    }

    fromCheck() {
        if (!this.partNo.PackagingInfos.length) {
            //this.addPcs();
            return "请输入收货件数";
        }

        var qty = Array.sum(this.partNo.PackagingInfos, e => (e.PCS || 0) * (e.Qty || 0) * (e.AsKilo ? 1000 : 1))
        // console.error(this.partNo.PackagingInfos);
        if (isNaN(qty)) return "收货数量为0";
        this.partNo.Qty = qty;
        // if (!this.partNo.CaseNo) return "请输入来货箱号";
        if (!this.partNo.PartNo) return "请输入实收型号";

    }

    doShowPicker(f: PickFields) {
        this.pnField = f;
        this.showPicker = true;
    }
    doShowPerview(img: ImageInfo) {
        var idx = this.imgs.indexOf(img);
        ImagePreview(this.imgUrls, Math.max(idx, 0));
    }

    onConfirm(item: OCRApi.IOCRResultItem, idx: number) {
        this.showPicker = false;
        this.$set(this.partNo, this.pnField as string, item.Text)
    }

    addPcs(): OCROrderApi.IReceiptPackagingInfo {
        if (!this.partNo.PackagingInfos) this.$set(this.partNo, "PackagingInfos", []);
        const pc: OCROrderApi.IReceiptPackagingInfo = {
            PCS: 1,
            AsKilo: false,
            Qty: undefined as any,
            AgentOrderDetailReceiptInfoId: undefined as any,
            Type: OCROrderApi.PackagingUnit.Reel
        }
        this.partNo.PackagingInfos.push(pc)
        return pc;
    }

    addRemark(txt: string) {
        if (this.partNo.Remark) this.partNo.Remark += " / ".concat(txt);
        else this.$set(this.partNo, "Remark", txt)
    }

    takePhoto(scan?: boolean) {
        this.ocrScan = scan || false
        //this.imgOCR("e86256bf-25f8-406a-8d96-97c9829a894f");
        var inp = this.$el.getElementsByClassName("photo")
        if (inp.length != 1) {
            Toast({ message: "未发现Input元素" })
            return;
        }
        this.$nextTick(() => (inp[0] as HTMLElement).click())
    }

    async getUploadPtr() {
        const ptr: CustomUploadApi.ICustomUploadParams = { type: C_UPLOAD_FILE_TYPE } as any
        if (this.detailInfo.partNoId) {
            ptr.relationId = this.detailInfo.partNoId;
            return ptr;
        }
        if (!this.sessionId) {
            var sid = await UploadApi.getSession();
            this.sessionId = sid.SessionId!
        }
        ptr.sessionId = this.sessionId;
        return ptr;
    }


    async photoOnChange(e: Event) {
        var cnt = e.target as HTMLInputElement;
        if (!cnt) return;
        var file = (cnt.files || [])[0];
        //        console.error(img)
        if (!file) return
        // this.imgOCR("e86256bf-25f8-406a-8d96-97c9829a894f");
        // const dlg = this.$loading({ text: "正在压缩图像" })
        var uploadTask = this.getUploadPtr();

        file = await this.imgToWebp(file);
        // this.$loading({ text: "正在上传图像" })

        var m: ImageInfo = { id: undefined, isFile: true, url: URL.createObjectURL(file), scanning: false };
        this.imgs.push(m);
        var frm = new FormData();
        frm.append("file", file);
        try {
            const rlt = await CustomUploadApi.upload(await uploadTask, frm);
            m.id = rlt.Id!;
            // URL.revokeObjectURL(m.url);
            // m.url = this.fileIdToUrl(rlt.Id!);
            // m.isFile = false;
            if (this.ocrScan) this.$nextTick(() => this.imgOCR(m));
        } catch {
            this.imgDel(m);
        }
    }

    async imgOCR(imgInfo: ImageInfo, replace?: boolean) {
        //const dlg = this.$loading({ text: "正在OCR识别" });
        if (!imgInfo.id) return Toast({ message: "正在上传" })
        this.$set(imgInfo, "scanning", true);
        console.error(imgInfo)

        OCRApi.scan({ FileID: imgInfo.id!, OrderId: this.detailInfo.orderId })
            .then(e => {
                imgInfo.ocr = e;
                this.ocrCallback(e, replace)
            })
            .finally(() => imgInfo.scanning = false)
    }
    async imgDel(imgFile: ImageInfo) {
        var idx = this.imgs.indexOf(imgFile)
        if (idx == -1) return;
        const action = await this.$dialog.confirm({ message: "是否删除该照片？" })
        if (action != "confirm") return
        if (imgFile.isFile) URL.revokeObjectURL(imgFile.url);
        this.imgs.splice(idx, 1)
        if (imgFile.id) UploadApi.del({ Id: imgFile.id })
    }

    async del() {
        if (this.detailInfo.partNoId) {
            await this.$dialog.confirm({ message: "是否要删除该理货明细？" });
            await OCROrderApi.deleteLine([this.detailInfo.partNoId])
            Toast("明细已经删除！")
            this.goBack(); //edit to back
            return;
        }

        await this.$dialog.confirm({ message: "是否清空当前填写的内容及照片？" });

        const imgs = this.imgs;
        imgs.forEach(e => {
            UploadApi.del({ Id: e.id });
            if (e.isFile) URL.revokeObjectURL(e.url);
        })
        this.newPartNo();
        Toast({ message: "内容已经清空" });
        return;
    }

    imgOcrChange(img: ImageInfo) {
        // if (img.scanning) return;
        this.ocrResult = (img.ocr || {}) as any
    }

    ocrCallback(params: OCRApi.IOCRResult, replace: boolean = false) {
        Toast({ message: "识别完成", duration: 1000 })
        this.ocrResult = params as any;
        var pn = this.partNo as { [key: string]: any }
        var keys: Array<keyof OCRApi.IOCRResult> = ["PartNo", "Brand", "DateCode", "RegionName"]
        keys.forEach(k => {
            const noValue = !pn[k];
            if (!(replace || noValue)) return;
            const items = params[k] as OCRApi.IOCRResultItem[];
            if (Array.isNullOrEmpty(items)) return;
            var max = 2;
            var text = ""
            for (var m of items) {
                var score = 0;
                if (m.Recommendder & OCRApi.OCRRecommendder.Order) score += 10;
                if (m.Recommendder & OCRApi.OCRRecommendder.AiVision) score += 2;
                if (m.Recommendder & OCRApi.OCRRecommendder.OpenSDK) score += 2;
                if (m.Recommendder & OCRApi.OCRRecommendder.Rule) score++;
                if (score < max) continue;
                text = m.Text!;
                max = score;
            }
            if (text) this.$set(pn, k, text);
        })

        var pc = Array.firstOrDefault(this.partNo.PackagingInfos);
        if (!pc) pc = this.addPcs();
        if (pc.Qty) return;

        var m = params.Qty.find(e => e.Recommendder & OCRApi.OCRRecommendder.AiVision);
        if (m && Number(m.Text) < 1) m = undefined;
        m = m || Array.firstOrDefault(params.Qty);
        if (!m) return;

        var qty = Number(m.Text);
        if (!qty) return;
        if ((qty % 1000) == 0) pc.Qty = qty;
        else if (m.Recommendder & OCRApi.OCRRecommendder.AiVision) pc.Qty = qty;
    }

    async imgToWebp(file: File): Promise<File> {
        const MAX_WIDTH = 1920;
        return await imageFileToWebp(file, MAX_WIDTH);
    }
    @Watch("partNo.PartNo")
    onPartNoChange(pn: string) {
        if (this.partNo.Package) return;
        if (!this.packages.length) return;
        this.partNo.Package = this.packages[0].Text;
    }
    @Watch("detailInfo.orderNo")
    orderNoOnChnage(orderNo: string) {
        eventBus.emit("upate-nav-title", orderNo);
    }
}
